<template>
  <body>
    <div class="main_top">
      <h1 class="detail_h1">
        <img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
        <span class="title">+- 승부예측</span>
        <div class="right">
          <a href="#" class="help">
            <div class="baloon">
              <p>게임 참가비 10FUS가 있으며, 오늘 기준 이틀 뒤의 해당 코인의 등락을 예상하고 모두 맞추신 분께 FUS가 지급됩니다.</p>
              <p>해당 코인에 투자하는것이 아니며, 해당 코인의 등락만을 기준으로 승패가 정해지는 게임입니다.</p>
              <p>참여자가 많을수록 지급되는 FUS가 늘어나며, 당첨자가 중복일 경우 전체 상금에서 당첨자 수만큼 나누어 지급됩니다.</p>
              <p>KST 00:00:00 ~ 23:59:59를 기준으로 합니다.</p>
            </div>
          </a>
        </div>
      </h1>
    </div>
    <div class="wrapper">
      <!-- title -->
      <div class="div_padding"></div>
      <div class="main_text_box">
        <h3>코인과 승부예측의 만남.</h3>
        <h3>참여자가 많을수록 <span id="thehae">더해</span>져요.</h3>
        <p>
          이틀 뒤의 코인의 등락을 예상하고 모두 맞춘 분께 FUS 지급!<br>
          참여자가 많을 수록 1등 당첨금이 점점 더해져요.
        </p>
      </div>
    </div>
    <!-- ball_list -->
    <div class="num_list">
      <!-- 횟수별 -->
        <div v-for="number in numList" :key="number" @click="toto_num(number)" :id="`ball${number}`" class="num_ball">
          {{ number }}
        </div>

    </div>
    <div class="wrapper">
      <div class="updown" id="bet">
        <div class="sub_text_box" id="toto_rank">
          <h3>
            <!-- <img src="images/basic/img/game-plusminus-title.svg" alt=""> -->
            {{num}}회차 <span class="count"> {{ count }}</span>
          </h3>
          <p>
            {{toto_date}}의 등락 예측. {{ closing_date }} 투표마감
          </p>

        </div>

        <div class="coin_rank_div">
          <div class="coin_rank_ul">
            <div class="coin_rank_list" v-for="(type, index) in type" :key="index">
              <div class="coin_rank_left">
                <div class="coin_logo" v-bind:style=" { backgroundImage:'url(' + type.logo + ')'}">
                </div>
                <div class="">
                  <p>{{ type.name }}</p>
                  <span v-if="type.change == 'zero'" class="zero">오늘 {{type.point}}%</span>
                  <span v-if="type.change == 'plus'" class="plus">오늘 {{type.point}}%</span>
                  <span v-if="type.change == 'minus'" class="minus">오늘 {{type.point}}%</span>
                </div>
              </div>
              <div class="coin_rank_right">
                <div class="plus">
                  <p></p>
                  <span>{{ type.plus }}명</span>
                </div>
                <div class="minus">
                  <p></p>
                  <span>{{ type.minus }}명</span>
                </div>
              </div>
            </div>
          </div>
          <div class="apply btn">
            <a href="#">코인 등락 + -를 선택하세요.</a>
          </div>
        </div>
      </div>
    </div>



    <div class="talk_wrapper">
      <p>TALK <span>130</span> <i class="fas fa-sync-alt"></i></p>

      <div class="talk_box">
        <textarea name="name"></textarea>
        <input type="button" name="" value="댓글">
      </div>

      <div class="talk_list">
        <!-- per talk -->
        <div class="talk_div">
          <div class="profile_pic" style="background-image: url(/images/basic/img/profile4@2x.png);">

          </div>
          <div class="text_box">
            <div class="">
              <p><span>Lv.9</span> Christopher Kalman <span class="time">5분전</span></p>
              <p class="text">
                업비트 기준으로 추세 시나리오~~
              </p>
            </div>
          </div>
        </div>

        <!-- per talk -->
        <div class="talk_div">
          <div class="profile_pic" style="background-image: url(/images/basic/img/profile3@2x.png);">

          </div>
          <div class="text_box">
            <div class="">
              <p><span>Lv.1</span> jasmine24 <span class="time">7분전</span></p>
              <p class="text">
                혹시 여기 a로 시작하는 사람 글보고 혹해서 투자하시는분들 계신가요?
              </p>
            </div>
          </div>
        </div>

      </div>

      <!-- talk_more -->
      <div class="talk_more">
        <p>더보기<i class="fas fa-chevron-down"></i></p>
      </div>
    </div>
  </body>
</template>

<script>
import $ from 'jquery';
export default {
  data() {
    return {
      toto_date: '2021.08.25',
      closing_date: '08.23',
      numList: [14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      num: 0,
      count: '21,987',
      round: '13',
      noti: '이틀 뒤의 코인의 등락을 예상하고 모두 맞추신 분께 FUS가 지급됩니다. KST 00:00:00 ~ 23:59:59를 기준으로 합니다.',
      type: [
        { name: 'Bitcoin', point: '+0.78', logo: '/images/basic/img/coin1@3x.png', plus: 9780, minus: 10980, change: 'zero' },
        { name: 'Etherium', point: '+0.78', logo: '/images/basic/img/coin2@3x.png', plus: 1780, minus: 4230, change: 'minus' },
        { name: 'Bitcoin', point: '-0.78', logo: '/images/basic/img/coin3@3x.png', plus: 9780, minus: 10980, change: 'plus' },
        { name: 'Bitcoin', point: '-0.78', logo: '/images/basic/img/coin4@3x.png', plus: 9780, minus: 10980, change: 'minus' },
        { name: 'Bitcoin', point: '+0.78', logo: '/images/basic/img/coin5@3x.png', plus: 9780, minus: 10980, change: 'plus' }
      ],
    }
  },
  mounted() {
    this.toto_num( 14 );
    $( '.coin_rank_ul .coin_rank_right > div' ).click( function () {
        $( this ).toggleClass( 'selected' ).siblings().removeClass( 'selected' );

      } );
      $( '.coin_rank_ul .coin_rank_list:last-child .coin_rank_right > div' ).click( function () {
        $( '.apply.btn' ).addClass( 'submit' );
        $( '.apply.btn a' ).text( '선택한 결과로 참여' );
      } )
  },
  methods: {
  toto_num( num ) {
    this.num = num;
     $( '.num_ball' ).removeClass( 'click' );
     $( '#ball' + num ).addClass( 'click' );
    }
  }
}
</script>

<style>

</style>